var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg071Forward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7 3.29C17.4536 3.00651 17.069 2.88504 16.7044 2.97552C16.3398 3.066 16.0567 3.35317 15.9714 3.719C15.8861 4.08483 16.013 4.4676 16.3 4.71L19.62 8H13C7.47715 8 3 12.4772 3 18V20C3 20.5523 3.44772 21 4 21C4.55228 21 5 20.5523 5 20V18C5 13.5817 8.58172 10 13 10H19.64L16.3 13.29C15.9123 13.68 15.9123 14.31 16.3 14.7C16.4846 14.8884 16.7362 14.9962 17 15C17.2623 14.9989 17.5137 14.8947 17.7 14.71L22.76 9.71C22.9493 9.52224 23.0558 9.26664 23.0558 9C23.0558 8.73337 22.9493 8.47777 22.76 8.29L17.7 3.29Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg071Forward);
export default __webpack_public_path__ + "static/media/071-forward.9cd4ceeda64c4ab19183a5cce6f06127.svg";
export { ForwardRef as ReactComponent };